import Image from "next/image";
import Link from "next/link";
import React from "react";

const SocialMediaLinks = ({ dataHeader }) => {
  const { facebook, instagram, youtube, telegram } =
    (dataHeader && dataHeader?.social) || {};

  const socialMedia = [
    { href: youtube, icon: "/icons/youtube.svg", alt: "youtube" },
    { href: facebook, icon: "/icons/facebook.svg", alt: "facebook" },
    { href: telegram, icon: "/icons/telegram.svg", alt: "telegram" },
    { href: instagram, icon: "/icons/instagram.svg", alt: "instagram" },
  ];
  return (
    <ul className="flex items-center gap-4">
      {socialMedia.map(
        (media, index) =>
          media.href && (
            <li key={index}>
              <Link href={media.href} target="_blank">
                <Image
                  src={media.icon}
                  alt={media.alt}
                  width={28}
                  height={28}
                />
              </Link>
            </li>
          )
      )}
    </ul>
  );
};

export default SocialMediaLinks;
